import {Card} from "../../../basic/card.tsx";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {useGetCurrentUserQuery} from "../../../../store/generated/api.ts";
import {UserSecurity, WorkOsWidgets} from "@workos-inc/widgets";

export function SecuritySettings() {
    const {t} = useTranslationWithKeys();
    const {data, isLoading} = useGetCurrentUserQuery();
    const user = data?.user;

    if (isLoading) {
        return (
            <Card className="p-6 shadow-sm border-border/50">
                <div className="flex items-center justify-center h-32">
                    <p className="text-muted-foreground">{t('common.loading')}</p>
                </div>
            </Card>
        );
    }

    if (!user?.workosToken) {
        return (
            <Card className="p-6 shadow-sm border-border/50">
                <div className="flex items-center justify-center h-32">
                    <p className="text-destructive">{t('settings.securityWidgetError')}</p>
                </div>
            </Card>
        );
    }

    return (
        <Card className="p-6 shadow-sm border-border/50 overflow-visible">
            <WorkOsWidgets
                theme={{
                    appearance: "inherit",
                    accentColor: "green",
                    radius: "medium"
                }}
            >
                <UserSecurity
                    authToken={user.workosToken}
                />
            </WorkOsWidgets>
        </Card>
    );
}